import React from 'react'
import styles from './styles.module.scss'
import { ft, gbn, itv, skyNews, theSun, bbc, dm } from '../../../assets/newsOutlets'

interface SocialProofProps {
    title?: string
    subtitle?: string
    className?: string
}

const SocialProof: React.FC<SocialProofProps> = ({
    title = 'As featured in',
    subtitle,
    className,
}) => {
    const logos = [
        { src: bbc, alt: 'BBC News', name: 'BBC' },
        { src: skyNews, alt: 'Sky News', name: 'Sky News' },
        { src: itv, alt: 'ITV', name: 'ITV' },
        { src: theSun, alt: 'The Sun', name: 'The Sun' },
        { src: dm, alt: 'Daily Mail', name: 'Daily Mail' },
        { src: ft, alt: 'Financial Times', name: 'Financial Times' },
        { src: gbn, alt: 'GB News', name: 'GB News' },
    ]

    // Duplicate the logos for seamless infinite scroll
    const duplicatedLogos = [...logos, ...logos]

    return (
        <div className={`${styles.socialProof} ${className || ''}`}>
            {title && <h3 className={styles.title}>{title}</h3>}
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            
            <div className={styles.logosContainer}>
                <div className={styles.logosTrack}>
                    {duplicatedLogos.map((logo, index) => (
                        <div key={`${logo.name}-${index}`} className={styles.logoWrapper}>
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                className={styles.logo}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default SocialProof
